/*****************************************************/
/* 処　理：SMS008 請求金額詳細 画面
/*
/* 概　要：定数定義
/*
/* 更新日：2025/01/08 HARAGU 00011_SMS機能等の導入支援
/*****************************************************/

// 処理名
export const INIT_NAME = '初期表示';
export const BTN_BARCODE_NAME = 'コンビニ払いバーコード発行';
export const BTN_KOZAINFO_NAME = '家賃振込先表示へ';
export const BTN_BACKMENU_NAME = 'メニューへ戻る';

// APIパス
export const API_INIT_PATH = '/SMS008/init';
export const API_EXECUTE_PATH = '/SMS008/execute';

